<template>
  <v-col 
    cols="12"
    sm="4"
    :md="showFilters ? 6 : 4"
    :lg="showFilters ? 4 : 3"
    :xl="3"
  >
    <v-card
      :height="450"
      class="reference-card"
      :loading="loading"
      :disabled="loading"
      :to="{name:'ShowReference', params:{id: id}}"
      href
    >

      <Ribbon
        v-if="isNew"
        text="Nouveauté"
        position="top-right"
        url=""
        :bgColor="colors.primary"
      ></Ribbon>
      <v-img
        :src="thumbnail"
        :max-height="370"
        :height="370"
      ></v-img>

      <v-card-title style="justify-content: center;">
        {{ name }}
      </v-card-title>

      <v-card-subtitle align="center" v-if="description != null" class="text-truncate">
        {{ description }}
      </v-card-subtitle>

    </v-card>
  </v-col>
</template>

<script>
  // COMPONENTS
  import Ribbon from '@/components/layout/Ribbon';

  export default {
    name: 'Card',

    components: {
      Ribbon,
    },

    data() {
      return {
        colors: this.$vuetify.theme.themes.light,
      }
    },
    
    props: {
      id: Number,
      name: String,
      description: String,
      thumbnail: String,
      exRef: String,
      showFilters: Boolean,
      isNew: Boolean,
      loading: Boolean,
    },
  }
</script>

<style scoped>
  .headline,
  .v-card__subtitle {
    color: #000 !important;
    font-size: 14px;
  }
</style>